import { render, staticRenderFns } from "./FriendshipLink.vue?vue&type=template&id=4e46ced4&"
import script from "./FriendshipLink.vue?vue&type=script&lang=js&"
export * from "./FriendshipLink.vue?vue&type=script&lang=js&"
import style0 from "./FriendshipLink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports